export default "__VITE_ASSET__CVvrFPAz__"